import { DateInput } from 'components/inputs/DateInput';
import { IFormInputSpecDate } from 'pages/revisions-module/template-editor/editors/form/types';

/**
 * Preview for a date input.
 */
export default function DateInputPreview({ spec }: { spec: IFormInputSpecDate }) {
  return <DateInput required={spec.required} readOnly={spec.readOnly} size="sm" />;
}
